import React, { createContext, useEffect, useRef, useState } from 'react';
import { io } from 'socket.io-client';

export const SocketContext = createContext();

const SocketProvider = ({ children }) => {
    const socketRef = useRef(null);
    const [online, setOnline] = useState(false);

    useEffect(() => {

        if (socketRef.current) return;

        const socketInstance = io(`${import.meta.env.VITE_BASE_URL}`, {
            transports: ['websocket', 'polling'],
            autoConnect: true,
            reconnection: true,
            reconnectionAttempts: 5,
            reconnectionDelay: 1000,
            withCredentials: true
        });

        socketRef.current = socketInstance;

        socketInstance.on('connect', () => {
            console.log('✅ Connected to server:', socketInstance.id);
            setOnline(true);

            const token = localStorage.getItem('token');

            if (token) {
                try {
                    const payload = JSON.parse(atob(token.split('.')[1]));

                    const isCaptainRoute = window.location.pathname.includes("captain");
                    const userType = isCaptainRoute ? "captain" : "user";

                    socketInstance.emit('join', {
                        userId: payload._id,
                        userType
                    });

                    console.log(`📡 Joined as ${userType}:`, payload._id);

                } catch (e) {
                    console.error('❌ Token error:', e);
                }
            }
        });

        socketInstance.on('disconnect', () => {
            console.log('❌ Disconnected');
            setOnline(false);
        });

        socketInstance.on('connect_error', (error) => {
            console.error('❌ Socket error:', error);
        });

        return () => { };

    }, []);

    return (
        <SocketContext.Provider value={{ socket: socketRef.current, online }}>
            {children}
        </SocketContext.Provider>
    );
};

export default SocketProvider;